<template>
  <SettingsSectionContainer>
    <SettingsSectionDetails :title="title" :description="description" />
    <ELYXToggleButton :isEnabled="isEnabled" @click="toggleButtonClicked" />
  </SettingsSectionContainer>
</template>

<script>
import ELYXToggleButton from "../../ELYXComponents/ELYXToggleButton.vue";
import SettingsSectionContainer from "./SettingsSectionContainer.vue";
import SettingsSectionDetails from "./SettingsSectionDetails.vue";

export default {
  components: {
    ELYXToggleButton,
    SettingsSectionContainer,
    SettingsSectionDetails,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    isEnabled: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggleButtonClicked() {
      this.$emit("click");
    },
  },
};
</script>
